<template>
  <div :class="['loading-wrap',`position-${position}`]">
    <div class="loading-imgWrap">
      <div class="loading-img">
        <img src="@/common/images/student/ic_upload_loading.png" alt="">
      </div>
      <p class="loading-text">{{title}}</p>
    </div>
  </div>
</template>
<script>
  export default {
    name: "TextLoading",
    props:{
      title: {
        type: String,
        default: "加载中..."
      },
      position: {
        type: String,
        default: "middle",
      }
    },
    data() {
      return {}
    }
  }
</script>
<style scoped lang="less">
.loading-wrap {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  pointer-events: none;
}
.loading-imgWrap {
  margin: 0 auto;
  width: 150px;
  height: 48px;
  border-radius: 13px;
  opacity: 1;
  // background: rgba(10, 17, 26, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .loading-img {
    width: 60px;
    height: 60px;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
    img{
      width: 100%;
    }
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}
.loading-text {
  margin-left: 10px;
  color: #4E5969;
  font-size: 14px;
}
.loading-wrap.position-top .loading-imgWrap {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loading-wrap.position-middle .loading-imgWrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loading-wrap.position-bottom .loading-imgWrap {
  position: absolute;
  bottom: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
